import { IsBoolean, IsString } from 'class-validator';

export class SubmitBasicInformationDto {
  @IsBoolean()
  isLegal!: boolean;

  @IsString()
  email!: string;
}
